import { useState, useEffect } from "react";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { heroVideo3 } from "../utils";

const Hero = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 760);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 760);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useGSAP(() => {
    gsap.to("#hero", {
      opacity: 1,
      delay: 1.5,
    });

    gsap.to("#cta", {
      opacity: 1,
      y: -50,
      delay: 1.5,
    });
  }, []);

  return (
    <section className="w-full h-screen bg-black relative flex flex-col items-center justify-center overflow-hidden">
      {/* Hero Title */}
      <div className="absolute top-6 left-1/2 transform -translate-x-1/2 text-center z-10 w-full px-4 md:px-6">
        <p
          id="hero"
          className="hero-title text-white text-3xl md:text-5xl font-extrabold leading-tight"
        >
          Some Of My Projects
        </p>
      </div>

      {/* Video Background */}
      <div className="w-full h-full absolute top-0 left-0 z-0">
        <video
          loop
          autoPlay
          muted
          playsInline
          key={heroVideo3}
          className="pointer-events-none w-full h-full object-cover absolute"
          style={{
            objectFit: "cover",
            objectPosition: "center center",
            width: "100%",
            height: "100%",
          }}
        >
          <source src={heroVideo3} type="video/mp4" />
        </video>

        {/* Mobile Overlay to darken video a bit for better text visibility */}
        {isMobile && (
          <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-40 z-10" />
        )}
      </div>

      {/* CTA Section */}
      <div
        id="cta"
        className="absolute bottom-16 flex flex-col items-center gap-3 opacity-0 transition-opacity duration-700 px-4 z-20"
      >
        <a
          href="#highlights"
          className="btn animate-bounce text-lg md:text-xl font-semibold py-2 px-6 md:px-8 bg-white text-black rounded-full shadow-lg hover:bg-gray-200 transition-all"
        >
          View More
        </a>
        <p className="font-normal text-base md:text-lg text-white text-center">
          Explore About My Projects
        </p>
      </div>
    </section>
  );
};

export default Hero;